import React, { useState } from 'react';

import communesByEPCI from './communesByEPCI.json';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const ModalEPCISelection = ({EPCISelection, setEPCISelection, onNext, close}) => {
  const list = Object.entries(communesByEPCI).map(([commune, EPCI]) => { return {commune, EPCI} });
  const handleChange = (e, value) => {
    setEPCISelection(value)
  }
  const handleSubmit = () => {
    close();
    onNext();
  }
  return (
    <div id="modal_epci">
        <h3 className="container_title">Sélection Commune</h3>
        <p>Merci d'indiquer votre commune de résidence : nous pourrons ainsi mieux identifier les volontés de chaque communauté de communes.</p>
        <p><i>(Tapez les premières lettres de votre commune, elle vous sera alors proposée)</i></p>

        <Autocomplete
          disablePortal
          id="combo-box-demo"
          options={list}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="Commune" />}
          getOptionLabel={(option) => option.commune}
          onChange={handleChange}
        />

        {EPCISelection && <p>Pour information, <b>{EPCISelection.commune}</b> fait partie de la communauté de communes "<b>{EPCISelection.EPCI}</b>"</p>}

        <div className='button_wrapper'>
          <button
            type="button"
            className="btn secondary-btn"
            onClick={onNext}
          >
            Annuler
          </button>
          <button
            type="button"
            className="btn primary-btn"
            onClick={handleSubmit}
          >
            Valider
          </button>
        </div>
    </div>
  )
}

export default ModalEPCISelection